// POS Page with Enhanced Keyboard Navigation and Improved Design
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories } from '../../../slices/company/finalCategorySlice';
import { API_URL } from '../../../utils/constant';
import axios from 'axios';
import { Country, State, City } from 'country-state-city';
import { CircleArrowOutUpLeft, LayoutGrid, LayoutList, Pen, RotateCcw, ScanBarcode, Search } from 'lucide-react';
import { Link, useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import PosModel from './Pos_model';
import moment from 'moment/moment';
import { BarcodeFormat, BrowserMultiFormatReader } from '@zxing/browser';
import { fetchCustomers } from '../../../slices/company/customerSlice';
import OtherScrapModal from './other_modal';
import StockOtherScrapModal from './stock_modal';
import Swal from 'sweetalert2';
import BillFormatA4Page from './bills_format/format_a4';
import BillFormatA5Page from './bills_format/format_a5';
import BillFormat3mmPage from './bills_format/format_3mm';


const buildReceiptHTML = (args) => BillFormat3mmPage(args);




const PosPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const draftIdFromUrl = searchParams.get('draft_id');
  const [editingDraftBillId, setEditingDraftBillId] = useState(null);
  const [editingDraftBillNo, setEditingDraftBillNo] = useState('');

  const dispatch = useDispatch();
  const [salesExecutive, setSalesExecutive] = useState(1);
  const [billType, setBillType] = useState('');
  const [paperSize, setPaperSize] = useState('A5');
  const [billingFor, setBillingFor] = useState('');
  const [salesExecutives, setSalesExecutives] = useState([]);
  // Payment mode and cash received state
  const [paymentMode, setPaymentMode] = useState('Cash');
  const [cashReceived, setCashReceived] = useState('');
  const [bankName, setBankName] = useState('');
  const [chequeNo, setChequeNo] = useState('');

  const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'
  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [search, setSearch] = useState('');
  const [cart, setCart] = useState([]);
  const [selectedProductIndex, setSelectedProductIndex] = useState(0);
  const [selectedCartIndex, setSelectedCartIndex] = useState(0);
  const [focusArea, setFocusArea] = useState('products'); // 'search', 'products', 'cart'
  const [showScanner, setShowScanner] = useState(false); // Default open
  const [scanningProduct, setScanningProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [scannedCode, setScannedCode] = useState("");
  const [scannerError, setScannerError] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const searchRef = useRef();
  const inputRef = useRef(null);
  const [status, setStatus] = useState(null)
  const scannerRef = useRef(null);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [invoiceNo, setInvoiceNo] = useState('');
  const [invoiceTaken, setInvoiceTaken] = useState(false);
  const [invoiceChecked, setInvoiceChecked] = useState(false);
  const { customers } = useSelector(state => state.customers);
  // const companyState = localStorage.getItem('company_state');
  const [customerName, setCustomerName] = useState('');
  const [customerMobile, setCustomerMobile] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerGstNo, setCustomerGstNo] = useState('');
  const [customerDlNo, setCustomerDlNo] = useState('');
  const [customerAadharNo, setCustomerAadharNo] = useState('');
  const [isWholesaler, setIsWholesaler] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const customerDropdownRef = useRef(null);
  const [showVariantModel, setshowVariantModel] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isOlderBill, setIsOlderBill] = useState(false);
  const [billDate, setBillDate] = useState(moment().format('YYYY-MM-DDTHH:mm'));

  const [selectedCountry, setSelectedCountry] = useState(); // India
  const [selectedState, setSelectedState] = useState('West Bengal'); // West Bengal
  const [selectedCity, setSelectedCity] = useState('Kolkata');
  const [companyData, setCompanyData] = useState([]);
  const [products, setProducts] = useState([]);


  const [partialFirstMode, setPartialFirstMode] = useState('');
  const [partialSecondMode, setPartialSecondMode] = useState('');
  const [partialFirstPayment, setPartialFirstPayment] = useState('');
  const [partialSecondPayment, setPartialSecondPayment] = useState('');

  const loginUserId = localStorage.getItem('user_id');
  const loginUserRole = localStorage.getItem('userRole');

  const [openOtherModal, setOtherModalOpen] = useState(false);
  const [openStockOtherModal, setStockOtherModalOpen] = useState(false);

  const { categories: categoryList = [] } = useSelector(state => state.finalCategory);

  // Fetch products and categories on mount
  useEffect(() => {
    const company = JSON.parse(localStorage.getItem('company'));
    if (company?.company?.id) {
      const companyId = company.company.id;
      // Use POS API instead of final products
      dispatch(fetchCustomers(companyId));
      // fetchPosProducts(companyId);
      fetchCompany(companyId);
      dispatch(fetchCategories(companyId));
      fetchSalesExecutives(companyId);
    }
    searchRef.current?.focus();
    setFocusArea('search');

    const draftId = draftIdFromUrl || location.state?.editDraftBill?.id;
    if (!draftId) {
      askOrderType();
    }
  }, [dispatch, draftIdFromUrl, location.state]);

  // Load and hydrate Draft Bill into POS Cart
  useEffect(() => {
    const draftId = draftIdFromUrl || location.state?.editDraftBill?.id;
    if (!draftId) return;

    const loadDraftBill = async () => {
      try {
        let draftData = location.state?.editDraftBill;
        if (!draftData) {
          const res = await axios.get(`${API_URL}/bills/${draftId}`);
          if (res.data && res.data.data) {
            draftData = res.data.data;
          } else if (res.data && res.data.bill) {
            draftData = res.data.bill;
          } else if (res.data) {
            draftData = res.data;
          }
        }

        if (draftData) {
          setEditingDraftBillId(draftData.id);
          setEditingDraftBillNo(draftData.bill_no || `DRAFT-${draftData.id}`);

          // Hydrate Cart
          if (Array.isArray(draftData.product_data)) {
            const hydratedCart = draftData.product_data.map((item, idx) => {
              const isLoose = item.is_loose || false;
              const realVariationId = item.serial_nos?.[0]?.variant_id || item.id_variation || item.variant_id || item.product_id;
              const bNo = item.batch_no ? String(item.batch_no).trim() : '';
              const yearVal = item.year || (item.price_date ? new Date(item.price_date).getFullYear() : '');
              const priceVal = parseFloat(item.price) || parseFloat(item.sale_cost) || 0;

              const cartKey = isLoose && item.dispense_info
                ? `${item.product_id}_dispense_${item.dispense_info.id}`
                : `${realVariationId}_b_${bNo}_y_${yearVal}_p_${priceVal}`;

              return {
                id: item.product_id,
                product_id: item.product_id,
                name: item.product_name || item.name || 'Product',
                product_name: item.product_name || item.name || 'Product',
                product_type: item.product_type,
                cartKey,
                sale_cost: priceVal,
                price: priceVal,
                batch_no: item.batch_no || '',
                year: item.year || '',
                price_date: item.price_date || null,
                qty: parseFloat(item.qty) || 1,
                serial_nos: item.serial_nos || [],
                discount_type: item.discount_type || 'percentage',
                discount_value: parseFloat(item.discount_value) || 0,
                is_free: !!item.is_free,
                free_qty: parseFloat(item.free_qty) || 0,
                billed_qty: parseFloat(item.billed_qty) || 0,
                hsn_sac: item.hsn_sac || item.hsn_code || item.hsn || item.taxes?.hsn_code || '',
                gst: item.gst,
                gst_included: item.gst_included,
                taxes: { rate: parseFloat(item.gst) || 0 },
                unit: item.unit,
                segment: item.segment,
                is_loose: isLoose,
                dispense_info: item.dispense_info,
                dispense_materials: item.dispense_materials,
                type: item.type
              };
            });
            setCart(hydratedCart);
          }

          // Hydrate Customer Info
          if (draftData.Customer) {
            setCustomerName(draftData.Customer.name || '');
            setCustomerMobile(draftData.Customer.phone || '');
            setCustomerEmail(draftData.Customer.email || '');
            setCustomerAddress(draftData.Customer.address || '');
            setCustomerGstNo(draftData.Customer.gst_no || '');
            setCustomerDlNo(draftData.Customer.dl_number || '');
            setCustomerAadharNo(draftData.Customer.aadhar_no || '');
            setIsWholesaler(draftData.Customer.is_wholesaler === 1);
            if (draftData.Customer.country) setSelectedCountry(draftData.Customer.country);
            if (draftData.Customer.state) setSelectedState(draftData.Customer.state);
            if (draftData.Customer.city) setSelectedCity(draftData.Customer.city);
          }

          // Hydrate Billing Settings
          if (draftData.bill_type) setBillType(draftData.bill_type);
          if (draftData.bill_for) setBillingFor(draftData.bill_for);
          if (draftData.salesExecutive) setSalesExecutive(draftData.salesExecutive);
          if (draftData.mode_of_payment) setPaymentMode(draftData.mode_of_payment);
          if (draftData.bill_no) setInvoiceNo(draftData.bill_no);
          if (draftData.discountType) setDiscountType(draftData.discountType);
          if (draftData.discountValue) setDiscountValue(draftData.discountValue);
        }
      } catch (err) {
        console.error('Error loading draft bill into POS:', err);
      }
    };

    loadDraftBill();
  }, [draftIdFromUrl, location.state]);

  const handleCancelDraftEdit = () => {
    setEditingDraftBillId(null);
    setEditingDraftBillNo('');
    setCart([]);
    setCustomerName('');
    setCustomerMobile('');
    setCustomerEmail('');
    setCustomerAddress('');
    setCustomerGstNo('');
    setInvoiceNo('');
    navigate('/pos', { replace: true });
  };

  const askOrderType = () => {
    Swal.fire({
      title: 'Select Order Type',
      text: "Please select the type of order to proceed",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Wholesale Order',
      cancelButtonText: 'Retail Order',
      confirmButtonColor: '#7367f0',
      cancelButtonColor: '#00c1d4',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.isConfirmed) {
        setBillType('Wholesale');
      } else {
        setBillType('Retail');
      }
    });
  };



  const fetchSalesExecutives = async (companyId) => {
    console.log('Logiin data ', loginUserId, loginUserRole)
    try {
      const res = await axios.get(`${API_URL}/companies/sales/executives/${companyId}`);
      const data = res.data;
      setSalesExecutives(data);

      if (loginUserRole != 'super-admin') {
        data.forEach((item) => {
          if (item.id == loginUserId) {
            setSalesExecutive(item.id);
          }
        });
      }

    } catch (err) {
      console.error("Failed to fetch sales executives:", err);
    }
  };

  const fetchCompany = async (companyId) => {
    try {
      const res = await axios.get(`${API_URL}/companies/${companyId}`);
      const data = res.data;
      setCompanyData(data);
    } catch (err) {
      console.error("Failed to fetch company:", err);
    }
  };

  useEffect(() => {
    const container = containerRef.current;

    const handleScroll = () => {
      if (!container || loading || !hasMore) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreProducts(); // near bottom
      }
    };

    container?.addEventListener('scroll', handleScroll);
    return () => container?.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore]);

  // Initialize barcode scanner
  // useEffect(() => {

  // }, [showScanner, isScanning]);

  useEffect(() => {
    setCountries(Country.getAllCountries());
  }, []);

  // Load state list when country changes
  useEffect(() => {
    if (!selectedCountry || !countries.length) return;

    const countryData = countries.find(c => c.name === selectedCountry);
    if (countryData?.isoCode) {
      const countryStates = State.getStatesOfCountry(countryData.isoCode);
      setStates(countryStates);
      setSelectedState(""); // Reset state & city when country changes
      setCities([]);
    }
  }, [selectedCountry, countries]);

  useEffect(() => {
    if (!selectedCountry || !selectedState || !countries.length || !states.length) return;

    const countryData = countries.find(c => c.name === selectedCountry);
    const stateData = states.find(s => s.name === selectedState);

    if (countryData?.isoCode && stateData?.isoCode) {
      const stateCities = City.getCitiesOfState(countryData.isoCode, stateData.isoCode);
      setCities(stateCities);
    }
  }, [selectedState, selectedCountry, countries, states]);

  useEffect(() => {
    setSelectedCountry("India");
  }, []);


  useEffect(() => {
    setSelectedState("West Bengal");
  }, [selectedCountry]);

  useEffect(() => {
    setSelectedCity("Kolkata");
  }, [selectedState]);

  // Fetch POS products
  const fetchPosProducts = async (companyId) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/pos/products/${companyId}?page=1&limit=20&search=${search}`);
      if (response.data.success) {
        setProducts(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching POS products:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadMoreProducts = async () => {
    // setLoading(true);
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company.company.id;
      const res = await axios.get(`${API_URL}/pos/products/${companyId}?page=${page}&limit=20&search=${search}`);
      const newProducts = res.data.data;

      setProducts(prev => [...prev, ...newProducts]);
      setHasMore(res.data.total > (page * 20));
      setPage(prev => prev + 1);
    } catch (err) {
      console.error("Failed to load more:", err);
    } finally {
      // setLoading(false);
    }
  };

  // Filter products by category and search
  const filteredProducts = products;

  // Handle search with API
  const handleSearch = async (searchTerm) => {
    if (searchTerm.trim() === '') {
      // If search is empty, fetch all products
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;
      if (companyId) {
        fetchPosProducts(companyId);
      }
      return;
    }

    const company = JSON.parse(localStorage.getItem('company'));
    const companyId = company?.company?.id;

    if (companyId) {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/pos/products/${companyId}/search?q=${encodeURIComponent(searchTerm)}`);
        if (response.data.success) {
          console.log(response.data.data)
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error('Error searching products:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchNextInvoiceNo = async (billForVal) => {
    if (!billForVal) {
      setInvoiceNo('');
      setInvoiceTaken(false);
      setInvoiceChecked(false);
      return;
    }
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;
      if (companyId) {
        const response = await axios.get(`${API_URL}/pos/next-invoice-no/${companyId}?bill_for=${billForVal}`);
        if (response.data.success) {
          setInvoiceNo(response.data.nextBillNo);
          setInvoiceTaken(false);
          setInvoiceChecked(true);
        }
      }
    } catch (error) {
      console.error('Error fetching next invoice number:', error);
    }
  };

  const checkInvoiceNo = async (invNo) => {
    if (!invNo || !invNo.trim()) return;
    try {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;
      if (companyId) {
        const excludeParam = editingDraftBillId ? `&exclude_bill_id=${editingDraftBillId}` : '';
        const response = await axios.get(`${API_URL}/pos/check-invoice-no/${companyId}?invoice_no=${encodeURIComponent(invNo.trim())}${excludeParam}`);
        if (response.data.success) {
          setInvoiceTaken(response.data.exists);
          setInvoiceChecked(true);
        }
      }
    } catch (error) {
      console.error('Error checking invoice number:', error);
    }
  };

  useEffect(() => {
    const company = JSON.parse(localStorage.getItem('company'));
    const companyId = company?.company?.id;
    if (companyId) {
      if (search && search.trim() !== '') {
        handleSearch(search);
      }
    }
  }, [billType]);



  // Add product to cart
  // const handleAddToCart = (product) => {
  //   setCart(prev => {
  //     const existing = prev.find(i => i.id === product.id);
  //     return existing
  //       ? prev.map(i => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i))
  //       : [...prev, { ...product, qty: 1 }];
  //   });
  // };

  // const handleAddToCart = ({product, variant_id, serial_no}) => {
  //   setCart(prev => {
  //     const existing = prev.find(i => i.id === product.id);
  //     const currentQty = existing ? existing.qty : 0;

  //     if (currentQty >= product.quantity) {
  //       // Do not add more if max reached
  //       return prev;
  //     }

  //     return existing
  //       ? prev.map(i =>
  //         i.id === product.id ? { ...i, qty: i.qty + 1 } : i
  //       )
  //       : [...prev, { ...product, qty: 1 }];
  //   });
  // };

  useEffect(() => {
    const focusInput = () => {
      // only auto-focus hidden input if not inside another field
      const isInFormField =
        document.activeElement?.tagName === 'INPUT' ||
        document.activeElement?.tagName === 'TEXTAREA' ||
        document.activeElement?.tagName === 'SELECT' ||
        document.activeElement?.isContentEditable;

      if (!isInFormField) {
        inputRef.current?.focus();
      }
    };

    focusInput();
    window.addEventListener('focus', focusInput);
    return () => window.removeEventListener('focus', focusInput);
  }, []);

  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      const isBarcodeChar = /^[A-Za-z0-9]$/.test(e.key) || e.key === 'Enter';

      // check if the current active element is a form input (text, textarea, select)
      const isInFormField =
        document.activeElement?.tagName === 'INPUT' ||
        document.activeElement?.tagName === 'TEXTAREA' ||
        document.activeElement?.tagName === 'SELECT' ||
        document.activeElement?.isContentEditable;

      if (isBarcodeChar && !isInFormField) {
        inputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleGlobalKeyDown, true);
    return () => window.removeEventListener('keydown', handleGlobalKeyDown, true);
  }, []);


  const handleAddToCart = ({ product, variant_id, serial_no, remove = false }) => {
    console.log('removving', remove);
    console.log('adding prrodct', variant_id, product, serial_no);
    const hasOldStock = cart.some(i => i.type === 'is_other');
    if (!remove && hasOldStock) {
      showOldStockAlert();
      return;
    }
    if (remove) {
      handleDecreaseQty(product.id, serial_no); // remove specific serial
      return;
    }

    setCart(prev => {
      // Build unique key per real variation ID, batch_no, year, and price
      const realVariationId = variant_id || product.id_variation || product.variation_id || product.id;
      const bNo = product.batch_no ? String(product.batch_no).trim() : '';
      const yearVal = product.year || (product.price_date ? new Date(product.price_date).getFullYear() : '');
      const priceVal = product.sale_cost || product.price || 0;

      const cartKey = product.is_loose && product.dispense_info
        ? `${product.id}_v_${realVariationId}_dispense_${product.dispense_info.id || (product.dispense_info.category + '_' + (product.dispense_info.medicineType || '') + '_' + (product.dispense_info.salesSize || product.dispense_info.doseCount || ''))}`
        : `${realVariationId}_b_${bNo}_y_${yearVal}_p_${priceVal}`;

      const itemPrice = product.is_loose
        ? (product.price || product.sale_cost || 0)
        : (billType === 'Wholesale'
          ? (product.wholesale_price !== undefined && product.wholesale_price !== null && product.wholesale_price > 0 ? product.wholesale_price : (product.price || product.sale_cost || 0))
          : (product.price || product.sale_cost || 0));

      const existing = prev.find(i => 
        (i.cartKey || i.id) === cartKey ||
        (!product.is_loose && !i.is_loose && 
         ((variant_id && i.serial_nos?.some(s => s.variant_id === variant_id)) || 
          (!variant_id && !product.variations?.length && (i.product_id || i.id) === (product.parent_product_id || product.id))) &&
         Math.abs((i.sale_cost || 0) - itemPrice) < 0.01 &&
         (bNo === '' || (i.batch_no || '') === bNo))
      );
      console.log('existing in cart:', existing);

      const availableQty = billType === 'Wholesale'
        ? (product.current_wholesale !== undefined && product.current_wholesale !== null ? product.current_wholesale : (product.qty || 0))
        : (product.is_loose ? parseFloat(product.available_qty !== undefined ? product.available_qty : (product.loose_qty || 0)) : (product.qty || 0));

      if (product.is_loose) {
        const deductPerUnit = parseFloat(product.loose_deduct_qty) || 1;
        const totalReservedVolumeInCart = prev
          .filter(item => {
            const itemVarId = item.serial_nos?.[0]?.variant_id || item.variant_id || item.id_variation || item.id;
            return item.is_loose && String(itemVarId) === String(realVariationId);
          })
          .reduce((sum, item) => sum + (parseFloat(item.qty) || 1) * (parseFloat(item.loose_deduct_qty) || 1), 0);

        if (availableQty > 0 && (totalReservedVolumeInCart + deductPerUnit) > availableQty) {
          const remainingVolume = Math.max(0, availableQty - totalReservedVolumeInCart);
          const maxUnits = Math.floor(remainingVolume / deductPerUnit);
          Swal.fire({
            icon: 'warning',
            title: 'Insufficient Loose Stock',
            text: `Cannot add more. Available loose stock for this variation is ${availableQty} (${totalReservedVolumeInCart} already in cart). Maximum additional units: ${maxUnits}.`
          });
          return prev;
        }
      }

      if (!existing) {
        const productName = product.name || product.product_name || 'Product';
        return [
          ...prev,
          {
            ...product,
            name: productName,
            product_name: productName,
            cartKey,
            sale_cost: itemPrice,
            available_qty: availableQty,
            hsn_sac: product.hsn_sac || product.hsn_code || product.hsn || product.taxes?.hsn_code || '',
            qty: 1, // always add 1 unit to cart
            serial_nos: serial_no ? [{ variant_id, serial_no }] : (variant_id ? [{ variant_id, serial_no: '' }] : []),
            discount_type: 'percentage',
            discount_value: 0,
            is_free: false,
            free_qty: 0
          }
        ];
      }

      // Check stock availability for sealed products
      if (!product.is_loose) {
        const countInCart = (existing?.serial_nos || []).filter(s => s.variant_id === variant_id).length;
        if (countInCart >= availableQty && availableQty > 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Out of Stock',
            text: `Only ${availableQty} units available for this variation.`
          });
          return prev;
        }
      }

      const targetKey = existing.cartKey || existing.id;
      return prev.map(i =>
        (i.cartKey || i.id) === targetKey
          ? {
            ...i,
            serial_nos: serial_no ? [...(i.serial_nos || []), { variant_id, serial_no }] : (i.serial_nos || []),
            qty: i.qty + 1
          }
          : i
      );
    });
  };


  const showOldStockAlert = () => {
    Swal.fire({
      icon: "warning",
      title: "Old Stock Sales",
      text: "The sales information is here for old stock. Complete the sales and then create bills for new stock or empty the stock with empty or cancel button.",
      confirmButtonText: "OK"
    });
  };


  // Decrease product quantity in cart
  const handleDecreaseQty = (cartKeyOrId, serialOrIndex = null) => {
    setCart(prev => {
      const item = prev.find(i => (i.cartKey || i.id) === cartKeyOrId);
      if (!item) return prev;

      let updatedSerials;

      if (serialOrIndex !== null) {
        updatedSerials = [...item.serial_nos];
        if (typeof serialOrIndex === 'number') {
          // Remove by index
          updatedSerials.splice(serialOrIndex, 1);
        } else {
          // Remove by serial_no (first occurrence)
          const index = updatedSerials.findIndex(s => s.serial_no === serialOrIndex);
          if (index !== -1) updatedSerials.splice(index, 1);
        }
      } else {
        // Remove last serial
        updatedSerials = [...item.serial_nos];
        updatedSerials.pop();
      }

      if (updatedSerials.length === 0) {
        // Remove entire item if no serials left
        return prev.filter(i => (i.cartKey || i.id) !== cartKeyOrId);
      }

      return prev.map(i =>
        (i.cartKey || i.id) === cartKeyOrId
          ? {
            ...i,
            qty: updatedSerials.length,
            serial_nos: updatedSerials
          }
          : i
      );
    });
  };



  // Keyboard navigation and shortcuts
  // const handleKeyDown = (e) => {
  //   if (e.key === '/') {
  //     searchRef.current?.focus();
  //     setFocusArea('search');
  //     e.preventDefault();
  //     return;
  //   }

  //   if (e.key === 'b' && e.ctrlKey) {
  //     setShowScanner(!showScanner);
  //     e.preventDefault();
  //     return;
  //   }

  //   if (focusArea === 'products') {
  //     if (e.key === 'ArrowDown') setSelectedProductIndex(i => Math.min(i + 1, filteredProducts.length - 1));
  //     if (e.key === 'ArrowUp') setSelectedProductIndex(i => Math.max(i - 1, 0));
  //     if (e.key === 'Enter') handleAddToCart(filteredProducts[selectedProductIndex]);
  //     if (e.key === 'Tab') {
  //       e.preventDefault();
  //       setFocusArea('cart');
  //       setSelectedCartIndex(0);
  //     }
  //   } else if (focusArea === 'cart') {
  //     if (e.key === 'ArrowDown') setSelectedCartIndex(i => Math.min(i + 1, cart.length - 1));
  //     if (e.key === 'ArrowUp') setSelectedCartIndex(i => Math.max(i - 1, 0));
  //     if (e.key === '+') {
  //       const item = cart[selectedCartIndex];
  //       if (item) handleAddToCart(item);
  //     }
  //     if (e.key === '-' || e.key === 'Backspace') {
  //       const item = cart[selectedCartIndex];
  //       if (item) handleDecreaseQty(item.id);
  //     }
  //     if (e.key === 'Tab') {
  //       e.preventDefault();
  //       setFocusArea('products');
  //     }
  //   }

  //   if (e.ctrlKey && e.key === 'e') {
  //     handleEmptyCart();
  //   }
  //   if (e.ctrlKey && e.key === 'p') {
  //     alert('Payment Triggered');
  //   }
  // };

  // Empty the cart
  const handleEmptyCart = () => setCart([]);


  //Changedd code things

  // const subtotal = cart.reduce((sum, item) => {
  //   const baseTotal = item.sale_cost * item.qty;
  //   const gst = item.taxes?.rate || 0;
  //   const isIncluded = item.gst_included;
  //   const taxAmount = baseTotal * gst / 100;
  //   return sum + (isIncluded ? baseTotal : baseTotal + taxAmount);
  // }, 0);

  // // Tax: always calculate for display
  // const tax = cart.reduce((sum, item) => {
  //   const baseTotal = item.sale_cost * item.qty;
  //   const gst = item.taxes?.rate || 0;
  //   const taxAmount = baseTotal * gst / 100;
  //   return sum + taxAmount;
  // }, 0);

  // // Total: just subtotal (tax already included if not gst_included)
  // const total = subtotal;

  // const [discountType, setDiscountType] = useState('fixed'); // 'fixed' or 'percentage'
  // const [discountValue, setDiscountValue] = useState(0);

  // // Calculate discount amount
  // const discountAmount = discountType === 'fixed'
  //   ? parseFloat(discountValue || 0)
  //   : (total * parseFloat(discountValue || 0) / 100);


  const getItemCalculations = (item) => {
    const effectiveQty = parseFloat(item.qty) || 0;
    const freeQty = item.is_free ? effectiveQty : Math.min(effectiveQty, parseFloat(item.free_qty || 0));
    const billedQty = item.is_free ? 0 : Math.max(0, effectiveQty - freeQty);

    const gst = item.taxes?.rate || 0;
    const isIncluded = item.gst_included;
    const itemInclusivePrice = isIncluded ? (parseFloat(item.sale_cost) || 0) : (parseFloat(item.sale_cost) || 0) * (1 + gst / 100);

    const originalInclusiveTotal = itemInclusivePrice * effectiveQty;
    const billedInclusiveGross = itemInclusivePrice * billedQty;

    let itemDiscountAmount = 0;
    let itemDiscountPercent = 0;
    if (!item.is_free && billedInclusiveGross > 0 && parseFloat(item.discount_value || 0) > 0) {
      const val = parseFloat(item.discount_value);
      if (item.discount_type === 'fixed') {
        itemDiscountAmount = Math.min(val, billedInclusiveGross);
        itemDiscountPercent = (itemDiscountAmount / billedInclusiveGross) * 100;
      } else {
        itemDiscountPercent = val;
        itemDiscountAmount = (billedInclusiveGross * val) / 100;
      }
    } else if (item.is_free) {
      itemDiscountPercent = 100;
      itemDiscountAmount = originalInclusiveTotal;
    }

    const itemNetInclusive = item.is_free ? 0 : Math.max(0, billedInclusiveGross - itemDiscountAmount);

    return {
      effectiveQty,
      freeQty,
      billedQty,
      gst,
      isIncluded,
      itemInclusivePrice,
      originalInclusiveTotal,
      billedInclusiveGross,
      itemDiscountAmount,
      itemDiscountPercent,
      itemNetInclusive
    };
  };

  const handleItemDiscountChange = (cartKeyOrId, field, value) => {
    setCart(prev => prev.map(item => {
      if ((item.cartKey || item.id) === cartKeyOrId) {
        return {
          ...item,
          [field]: value
        };
      }
      return item;
    }));
  };

  const handleItemFreeToggle = (cartKeyOrId) => {
    setCart(prev => prev.map(item => {
      if ((item.cartKey || item.id) === cartKeyOrId) {
        const nextFree = !item.is_free;
        return {
          ...item,
          is_free: nextFree,
          free_qty: nextFree ? item.qty : 0
        };
      }
      return item;
    }));
  };

  const handleItemFreeQtyChange = (cartKeyOrId, freeQty) => {
    setCart(prev => prev.map(item => {
      if ((item.cartKey || item.id) === cartKeyOrId) {
        const val = Math.max(0, Math.min(item.qty, parseFloat(freeQty) || 0));
        return {
          ...item,
          free_qty: val,
          is_free: val >= item.qty && item.qty > 0
        };
      }
      return item;
    }));
  };

  const subtotal = cart.reduce((sum, item) => {
    const calc = getItemCalculations(item);
    return sum + calc.itemNetInclusive;
  }, 0);

  // Calculate discount on inclusive price
  const [discountType, setDiscountType] = useState('fixed'); // 'fixed' or 'percentage'
  const [discountValue, setDiscountValue] = useState(0);

  const discountAmount = discountType === 'fixed'
    ? parseFloat(discountValue || 0)
    : (subtotal * parseFloat(discountValue || 0) / 100);

  const totalAfterDiscount = Math.max(subtotal - discountAmount, 0);

  const totalLineItemDiscounts = cart.reduce((sum, item) => {
    return sum + getItemCalculations(item).itemDiscountAmount;
  }, 0);

  // Calculate taxes on discounted inclusive price
  const tax = cart.reduce((sum, item) => {
    const calc = getItemCalculations(item);
    const itemNetInclusive = calc.itemNetInclusive;
    const gst = calc.gst;

    // Proportion of this item's net inclusive in overall subtotal
    const itemProportion = subtotal > 0 ? itemNetInclusive / subtotal : 0;
    const itemFinalInclusive = totalAfterDiscount * itemProportion;

    // Back-calculate tax from the final inclusive amount for this item
    const taxAmount = itemFinalInclusive - (itemFinalInclusive / (1 + gst / 100));

    return sum + taxAmount;
  }, 0);

  // Total = total after discount (inclusive)
  const total = totalAfterDiscount;

  // For display rounding consistency
  const cgst_sgst_val = parseFloat((tax / 2).toFixed(2));
  const igst_val = parseFloat(tax.toFixed(2));
  const displayTaxableAmount = companyData?.state == selectedState
    ? (total - (cgst_sgst_val * 2))
    : (total - igst_val);

  // Handle category selection (ensure IDs are numbers)
  const handleCategorySelect = async (cat) => {
    setSelectedCategory(cat === 'All Categories' ? 'All Categories' : Number(cat));
    setSelectedProductIndex(0);

    // If a specific category is selected, fetch products for that category
    if (cat !== 'All Categories') {
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      if (companyId) {
        try {
          setLoading(true);
          const response = await axios.get(`${API_URL}/api/pos/products/${companyId}/category/${cat}`);
          if (response.data.success) {
            setProducts(response.data.data);
          }
        } catch (error) {
          console.error('Error fetching products by category:', error);
        } finally {
          setLoading(false);
        }
      }
    } else {
      // If "All Categories" is selected, fetch all products
      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      if (companyId) {
        fetchPosProducts(companyId);
      }
    }
  };

  const handleBarcodeStart = () => {
    setIsScanning(prev => !prev);
    setShowScanner(prev => !prev);
  };

  useEffect(() => {
    if (!showScanner || !scannerRef.current) return;

    const codeReader = new BrowserMultiFormatReader();

    setIsScanning(true);

    codeReader.decodeFromVideoDevice(null, scannerRef.current, (result, err, controls) => {
      if (result) {
        const code = result.getText();
        console.log("Scanned Code:", code);

        setScannedCode(code);
        // setIsScanning(false);
        // controls.stop(); // stop after successful scan
        handleBarcodeScan(code);
      }

      if (err && err.name !== 'NotFoundException') {
        console.error("Scanner error:", err);
        setScannerError("Scanner error or no barcode found.");
      }
    });

    // return async () => {
    //   await codeReader.stopContinuousDecode();
    //   await codeReader.stopStreams(); // clean up on unmount or toggle
    // };
  }, [showScanner]);


  // useEffect(() => {
  //   if (!showScanner) return;

  //   let Quagga;
  //   try {
  //     Quagga = require("quagga");
  //   } catch (error) {
  //     console.warn("Quagga not available:", error);
  //     setScannerError("Barcode scanner is not available.");
  //     return;
  //   }

  //   if (!scannerRef.current) {
  //     console.warn("Scanner target not ready");
  //     return;
  //   }

  //   Quagga.init(
  //     {
  //       inputStream: {
  //         name: "Live",
  //         type: "LiveStream",
  //         target: scannerRef.current,
  //         constraints: {
  //           width: 520,
  //           height: 200,
  //           facingMode: "user",
  //           aspectRatio: { min: 1, max: 2 }
  //         },
  //       },
  //       locator: {
  //         patchSize: "medium",
  //         halfSample: true,
  //       },
  //       numOfWorkers: 2,
  //       frequency: 5,
  //       decoder: {
  //         readers: ["code_128_reader"],
  //         multiple: false,
  //       },
  //       locate: true,
  //     },
  //     (err) => {
  //       if (err) {
  //         console.error("Quagga init error:", err);
  //         setScannerError("Failed to initialize scanner.");
  //         return;
  //       }
  //       Quagga.start();
  //       setIsScanning(true);
  //     }
  //   );

  //   Quagga.onDetected((data) => {
  //     const code = data?.codeResult?.code;
  //     const format = data?.codeResult?.format;
  //     console.log(code);
  //     if (code && format === 'code_128') {
  //       setScannedCode(code);
  //       Quagga.stop();
  //       Quagga.offDetected();
  //       setIsScanning(false);
  //       handleBarcodeScan(code);
  //     } else if (code) {
  //       setScannerError(`Unsupported barcode format: ${format}`);
  //     }
  //   });

  //   return () => {
  //     Quagga.stop();
  //     Quagga.offDetected();
  //   };
  // }, [showScanner]);



  // useEffect(() => {
  //   return () => {
  //     try {
  //       const Quagga = require("quagga");
  //       Quagga.stop();
  //       Quagga.offDetected();
  //     } catch (e) { }
  //   };
  // }, []);

  // Handle barcode scan
  // const handleBarcodeScan = async (barcode) => {
  //   try {
  //     setScanningProduct({ barcode, loading: true });
  //     setScannerError(null);

  //     const company = JSON.parse(localStorage.getItem('company'));
  //     const companyId = company?.company?.id;

  //     if (!companyId) {
  //       throw new Error('Company not found');
  //     }

  //     // Search for POS product by barcode
  //     const response = await axios.get(`${API_URL}/pos/products/${companyId}/barcode/${barcode}`);

  //     if (response.data && response.data.success && response.data.data) {
  //       const product = response.data.data;

  //       // Add product to cart
  //       handleAddToCart(product);

  //       // Focus cart and show success
  //       setFocusArea('cart');
  //       setSelectedCartIndex(cart.length);
  //       setScanningProduct({ barcode, success: 'Product added to cart!' });

  //       // Auto-hide success message after 2 seconds
  //       setTimeout(() => {
  //         setScanningProduct(null);
  //       }, 2000);
  //     } else {
  //       throw new Error('Product not found');
  //     }
  //   } catch (error) {
  //     console.error('Error scanning barcode:', error);
  //     setScanningProduct({ barcode, error: 'Product not found' });

  //     // Auto-hide error message after 3 seconds
  //     setTimeout(() => {
  //       setScanningProduct(null);
  //     }, 3000);
  //   }

  //   // Restart scanner after processing
  //   setTimeout(() => {
  //     setIsScanning(true);
  //     let Quagga;
  //     try {
  //       Quagga = require("quagga");
  //       Quagga.start();
  //     } catch (error) {
  //       console.error('Error restarting scanner:', error);
  //     }
  //   }, 1000);
  // };

  const handleBarcodeScan = async (barcode) => {
    try {
      setScanningProduct({ barcode, loading: true });
      setScannerError(null);

      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      if (!companyId) throw new Error('Company not found');

      // 🔍 1. Fetch product info using scanned barcode
      const response = await axios.get(`${API_URL}/pos/products/${companyId}/barcode/${barcode}`);

      if (!response.data?.success || !response.data.data) {
        throw new Error('Product not found');
      }

      const product = response.data.data;

      // 🧠 2. Determine if it's a variant-based product
      if (product.product_type === "variant") {
        const matchedVariation = product.variations?.find(v => v.barcode === barcode);

        if (!matchedVariation) throw new Error("Matching serial not found");

        handleAddToCart({
          product,
          variant_id: matchedVariation.id,
          serial_no: matchedVariation.serial_no
        });

      } else {
        // Simple product
        handleAddToCart({
          product,
          variant_id: null,
          serial_no: null
        });
      }

      // ✅ 3. Show success
      setFocusArea('cart');
      setSelectedCartIndex(cart.length);
      setScanningProduct({ barcode, success: 'Product added to cart!' });

      setTimeout(() => setScanningProduct(null), 2000);

    } catch (error) {
      console.error('Error scanning barcode:', error);
      setScanningProduct({ barcode, error: error.message || 'Scan failed' });
      setTimeout(() => setScanningProduct(null), 3000);
    }
  };

  // Handle product card click (add to cart and focus cart)
  const handleProductCardClick = ({ product, variant_id, serial_no, remove = false }) => {
    console.log('produt addaa', product);
    handleAddToCart({ product, variant_id, serial_no, remove });
    setFocusArea('cart');
    setSelectedCartIndex(cart.length); // Focus new item
  };

  const random4Digit = () => Math.floor(1000 + Math.random() * 9000);

  const handleAddOtherProduct = ({ product_data, remove = false }) => {
    console.log('product data', product_data);
    const hasNewStock = cart.some(i => i.type !== 'is_other');
    if (!remove && hasNewStock) {
      showOldStockAlert();
      return;
    }
    setCart(prev => {
      // Generate unique key for non-db products
      const tempId = product_data.temp_id || `OTHER_${product_data.product_serial}`;

      const existing = prev.find(i => i.id === tempId);

      // 🔴 REMOVE
      if (remove) {
        if (!existing) return prev;

        const updatedSerials = existing.serial_nos.slice(0, -1);

        if (updatedSerials.length === 0) {
          return prev.filter(i => i.id !== tempId);
        }

        return prev.map(i =>
          i.id === tempId
            ? {
              ...i,
              qty: updatedSerials.length,
              serial_nos: updatedSerials
            }
            : i
        );
      }

      // 🟢 ADD
      if (!existing) {
        return [
          ...prev,
          {
            id: tempId,
            gst: false,
            gst_included: true,
            product_type: product_data.product_type,
            product_for: product_data.product_for,
            type: 'is_other',
            name: product_data.product_name,
            sale_cost: product_data.product_price,
            taxes: {
              rate: Number(product_data.product_tax || 0)
            },
            size: product_data.product_size,
            color: product_data.product_color,
            qty: Number(product_data.product_qty),
            quantity: Number(product_data.product_qty), // no limit
            serial_nos: Array.from(
              { length: Number(product_data.product_qty) },
              (_, i) => ({
                variant_id: `${product_data.product_size}-${product_data.product_color}`,
                serial_no:
                  product_data.product_serial
                    ? `${product_data.product_serial}-${random4Digit()}`
                    : `MANUAL-${Date.now()}-${i}`
              })
            ),
            discount_type: 'percentage',
            discount_value: 0,
            is_free: false,
            free_qty: 0
          }
        ];
      }

      // 🟡 UPDATE EXISTING
      return prev.map(i =>
        i.id === tempId
          ? {
            ...i,
            qty: i.qty + Number(product_data.product_qty),
            serial_nos: [
              ...i.serial_nos,
              ...Array.from(
                { length: Number(product_data.product_qty) },
                (_, idx) => ({
                  variant_id: null,
                  serial_no:
                    product_data.product_serial
                      ? `${product_data.product_serial}-${i.serial_nos.length + idx + 1}`
                      : `MANUAL-${Date.now()}-${idx}`
                })
              )
            ]
          }
          : i
      );
    });
  };


  const handleProductVariant = (product, idx) => {
    setSelectedProduct(product);
    setshowVariantModel(true);
  }


  const handleStockDetailModel = (product, idx) => {
    setSelectedProduct(product);
    setStockOtherModalOpen(true);
  }

  const handleModelclose = () => {
    setshowVariantModel(false);
    setSelectedProduct([]);
  }

  // Fill all customer fields from a customer object
  const fillCustomerFields = (customer) => {
    setCustomerName(customer.name || '');
    setCustomerMobile(customer.phone || '');
    setCustomerEmail(customer.email || '');
    setSelectedCountry(customer.country || 'India');
    setSelectedState(customer.state || 'West Bengal');
    setSelectedCity(customer.city || 'Kolkata');
    setCustomerAddress(customer.address || '');
    setCustomerGstNo(customer.gst_no || customer.gst_number || '');
    setCustomerDlNo(customer.dl_number || customer.dl_no || '');
    setCustomerAadharNo(customer.aadhar_no || customer.aadhar_number || '');
    const isW = !!customer.is_wholesaler;
    setIsWholesaler(isW);
    if (isW) {
      setBillType('Wholesale');
    }
  };

  // Clear all customer fields
  const clearCustomerFields = () => {
    setCustomerName("");
    setCustomerMobile("");
    setSelectedCountry("India");
    setCustomerEmail("");
    setSelectedState('West Bengal');
    setSelectedCity("Kolkata");
    setCustomerAddress("");
    setCustomerGstNo("");
    setCustomerDlNo("");
    setCustomerAadharNo("");
    setIsWholesaler(false);
  };

  const callCustomerDataApi = async (e) => {
    const mobile = e.target.value;
    setCustomerMobile(mobile);

    // Only check when mobile length is 10
    if (mobile.length < 10) {
      clearCustomerFields();
      setCustomerMobile(mobile); // restore mobile since clearCustomerFields clears it
      return;
    };
    const customerSingle = customers.find(
      (c) => String(c.phone) === String(mobile)
    );

    console.log('cust', customerSingle);
    if (customerSingle) {
      fillCustomerFields(customerSingle);
    } else {
      clearCustomerFields();
      setCustomerMobile(mobile); // restore mobile since clearCustomerFields clears it
    }
  };

  // Customer name search handler
  const handleCustomerNameSearch = (e) => {
    const name = e.target.value;
    setCustomerName(name);

    if (name.trim().length >= 2) {
      const filtered = customers.filter((c) =>
        c.name && c.name.toLowerCase().includes(name.toLowerCase())
      ).slice(0, 10); // limit to 10 results
      setFilteredCustomers(filtered);
      setShowCustomerDropdown(filtered.length > 0);
    } else {
      setFilteredCustomers([]);
      setShowCustomerDropdown(false);
    }
  };

  // Select customer from dropdown
  const handleSelectCustomer = (customer) => {
    fillCustomerFields(customer);
    setShowCustomerDropdown(false);
    setFilteredCustomers([]);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (customerDropdownRef.current && !customerDropdownRef.current.contains(event.target)) {
        setShowCustomerDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);



  const handlePayment = async (isDraft) => {
    try {

      // console.log(partialFirstMode);
      // console.log(partialSecondMode);

      if (!billType) {
        alert('Bill Type is required');
        return;
      }

      if (!billingFor) {
        alert('Billing For is required');
        return;
      }
      // return;
      // if (paymentMode == 'Cash' && cashReceived < totalAfterDiscount) {
      //   alert('Received Cash is not less than Total Amount');
      //   return;
      // }


      const company = JSON.parse(localStorage.getItem('company'));
      const companyId = company?.company?.id;

      if (invoiceTaken) {
        alert('Invoice number is already taken. Please enter a different one.');
        return;
      }

      if (invoiceNo && invoiceNo.trim() !== '') {
        const excludeParam = editingDraftBillId ? `&exclude_bill_id=${editingDraftBillId}` : '';
        const checkRes = await axios.get(`${API_URL}/pos/check-invoice-no/${companyId}?invoice_no=${encodeURIComponent(invoiceNo.trim())}${excludeParam}`);
        if (checkRes.data.success && checkRes.data.exists) {
          setInvoiceTaken(true);
          alert('Invoice number has already been created. Please enter a different one.');
          return;
        }
      }


      const customer = {
        name: customerName,
        mobile: customerMobile,
        email: customerEmail,
        address: customerAddress,
        country: selectedCountry,
        state: selectedState,
        city: selectedCity,
        gst_no: customerGstNo,
      }

      let payable = parseFloat(totalAfterDiscount);

      if (paymentMode === 'Partial Payment') {
        payable =
          partialFirstMode === 'Cash'
            ? parseFloat(partialFirstPayment)
            : parseFloat(partialSecondPayment);
      }

      const received = parseFloat(cashReceived || 0);

      // ✅ Common calculations
      const cashReturn = received > payable ? Math.ceil(received - payable) : 0;
      const remainingAmount = received < payable ? Math.ceil(payable - received) : 0;



      const paymentData = {
        draft_bill_id: editingDraftBillId || undefined,
        cart: cart.map(item => {
          const calc = getItemCalculations(item);
          return {
            ...item,
            discount_type: item.discount_type || 'percentage',
            discount_value: parseFloat(item.discount_value) || 0,
            discount_amount: calc.itemDiscountAmount,
            discount_percent: calc.itemDiscountPercent,
            is_free: item.is_free ? 1 : 0,
            free_qty: calc.freeQty,
            billed_qty: calc.billedQty,
            line_net_amount: calc.itemNetInclusive
          };
        }),
        customer,
        total: totalAfterDiscount,
        tax,
        isDraft: isDraft ? 1 : 0,
        mode_of_payment: paymentMode,
        bill_for: billingFor,
        bill_type: billType,
        salesExecutive: salesExecutive,
        loginUserId: loginUserId,
        bill_date: isOlderBill ? billDate : null,
        custom_bill_no: invoiceNo
      };

      if (paymentMode === 'Cash') {
        paymentData.cash_received = received;
        paymentData.cash_return = cashReturn;
        paymentData.remaining_amount = remainingAmount;
      }

      // ✅ Cheque Payment
      if (paymentMode === 'Cheque') {
        if (!bankName || !chequeNo) {
          alert('Please enter bank name and cheque number');
          return;
        }

        paymentData.bank_name = bankName;
        paymentData.cheque_no = chequeNo;
        paymentData.cash_received = received;
        paymentData.remaining_amount = remainingAmount;
      }
      if (paymentMode === 'Partial Payment') {
        paymentData.partial_first_mode = partialFirstMode;
        paymentData.partial_second_mode = partialSecondMode;
        paymentData.partial_first_payment = partialFirstPayment;
        paymentData.partial_second_payment = partialSecondPayment;
        paymentData.cash_received = received;
        paymentData.cash_return = cashReturn;
        paymentData.remaining_amount = remainingAmount;

        // 👉 Cheque inside partial
        if (partialFirstMode === 'Cheque' || partialSecondMode === 'Cheque') {
          if (!bankName || !chequeNo) {
            alert('Please enter bank name and cheque number');
            return;
          }

          paymentData.bank_name = bankName;
          paymentData.cheque_no = chequeNo;
        }
      }
      if (discountValue > 0) {
        paymentData.discountType = discountType;
        paymentData.discountValue = discountValue;
        paymentData.discountAmount = discountAmount;
      }

      console.log('payment data', paymentData);
      // Send cart, customer, and payment info to your API
      const response = await axios.post(`${API_URL}/pos/products/checkout/${companyId}`, paymentData);

      const saleData = response.data?.bill;
      setCart([]);
      setPaymentMode('Cash');
      setPartialFirstMode('');
      setPartialSecondMode('');
      setPartialFirstPayment('');
      setPartialSecondPayment('');
      setDiscountType('fixed');
      setDiscountValue(0);
      setCustomerName('');
      setCustomerMobile('');
      setCashReceived('');
      setCustomerGstNo('');
      setCustomerDlNo('');
      setCustomerAadharNo('');
      setIsWholesaler(false);
      // reagainCallProducts();
      setBankName('');
      setChequeNo('');
      setInvoiceNo('');
      setInvoiceTaken(false);
      setInvoiceChecked(false);

      if (isDraft) {
        Swal.fire({
          icon: 'success',
          title: editingDraftBillId ? 'Draft Updated!' : 'Draft Saved!',
          text: editingDraftBillId ? 'Draft bill updated successfully.' : 'Bill saved as draft.',
          timer: 1500,
          showConfirmButton: false
        });
        setEditingDraftBillId(null);
        setEditingDraftBillNo('');
        return;
      }

      setEditingDraftBillId(null);
      setEditingDraftBillNo('');

      let withHeader = true;
      if (paperSize !== '80mm') {
        const layoutChoice = await Swal.fire({
          title: 'Choose Print Layout',
          text: 'Do you want to print with the header or without the header (pre-printed background)?',
          icon: 'question',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'With Header',
          denyButtonText: 'Without Header',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#3085d6',
          denyButtonColor: '#5c636a',
        });

        if (layoutChoice.isDismissed) return;
        withHeader = layoutChoice.isConfirmed;
      }

      // Open print popup
      const printWindow = window.open('', '_blank');

      let htmlContent = '';
      if (billType === 'Wholesale') {
        htmlContent = BillFormatA4Page({ companyData, data: saleData, withHeader });
      } else {
        // Retail
        if (paperSize === '80mm') {
          htmlContent = buildReceiptHTML({ companyData, data: saleData });
        } else {
          htmlContent = BillFormatA5Page({ companyData, data: saleData, withHeader });
        }
      }

      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.onload = () => {
        const images = printWindow.document.images;
        let loadedCount = 0;

        const handleLoadOrError = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            // printWindow.focus();
            // printWindow.print();
          }
        };

        for (let img of images) {
          img.onload = handleLoadOrError;
          img.onerror = handleLoadOrError;
        }

        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
      // printWindow.focus();
      // printWindow.print();
      // printWindow.close();
    } catch (error) {
      console.error("Payment failed:", error);
      // alert("Failed to process payment");
    }
  };

  const handleCleanSearch = async () => {
    setSearch('');
    const company = JSON.parse(localStorage.getItem('company'));
    if (company?.company?.id) {
      const companyId = company.company.id;
      // Use POS API instead of final products
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/pos/products/${companyId}?page=1&limit=20`);
        if (response.data.success) {
          setProducts(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching POS products:', error);
      } finally {
        setLoading(false);
      }
    }
    searchRef.current?.focus();
    setFocusArea('search');
  }


  const reagainCallProducts = () => {
    const company = JSON.parse(localStorage.getItem('company'));
    if (company?.company?.id) {
      const companyId = company.company.id;
      // Use POS API instead of final products
      fetchPosProducts(companyId);
      dispatch(fetchCategories(companyId));
    }
    searchRef.current?.focus();
    setFocusArea('search');
  };

  // Edit price handler
  const handleEditPrice = async (item) => {
    const newPriceStr = window.prompt('Enter new price for this item:', item.sale_cost);
    if (!newPriceStr) return;
    const newPrice = parseFloat(newPriceStr);
    if (isNaN(newPrice) || newPrice <= 0) {
      alert('Invalid price.');
      return;
    }

    console.log("Updating price for item:", item);
    try {
      // Call API to update price on server
      // await axios.put(`${API_URL}/pos/products/${item.parent_product_id}/update-price`, { variant_name: item.variant_name, price: newPrice });
      // Update price in cart state
      setCart(prev => prev.map(i => (i.cartKey || i.id) === (item.cartKey || item.id) ? { ...i, sale_cost: newPrice } : i));
      //  const company = JSON.parse(localStorage.getItem('company'));
      // const companyId = company.company.id;
      // fetchPosProducts(companyId);
    } catch (err) {
      alert('Failed to update price on server.');
      console.error(err);
    }
  };

  const handleEditQty = (item) => {
    const newQtyStr = window.prompt(`Enter quantity for ${item.name || item.product_name}:`, item.qty);
    if (newQtyStr === null) return;
    const newQty = parseFloat(newQtyStr);
    if (isNaN(newQty) || newQty <= 0) {
      alert('Invalid quantity.');
      return;
    }

    if (item.is_loose) {
      const deductPerUnit = parseFloat(item.loose_deduct_qty) || 1;
      const avail = parseFloat(item.available_qty !== undefined ? item.available_qty : (item.loose_qty || 0));
      const needed = newQty * deductPerUnit;
      if (avail > 0 && needed > avail) {
        const maxUnits = Math.floor(avail / deductPerUnit);
        Swal.fire({
          icon: 'warning',
          title: 'Insufficient Loose Stock',
          text: `Cannot set quantity to ${newQty}. Available stock is ${avail} (Max: ${maxUnits} unit${maxUnits !== 1 ? 's' : ''}).`
        });
        return;
      }
    } else if (item.available_qty > 0 && newQty > item.available_qty) {
      Swal.fire({
        icon: 'warning',
        title: 'Insufficient Stock',
        text: `Only ${item.available_qty} units available for this product.`
      });
      return;
    }

    setCart(prev => prev.map(i => {
      if ((i.cartKey || i.id) === (item.cartKey || item.id)) {
        let updatedSerials = [...(i.serial_nos || [])];
        if (!i.is_loose) {
          const currentCount = updatedSerials.length;
          const targetCount = Math.round(newQty);
          if (targetCount < currentCount) {
            updatedSerials = updatedSerials.slice(0, targetCount);
          } else if (targetCount > currentCount) {
            const base = updatedSerials[0] || { variant_id: i.variant_id || i.product_id, serial_no: '' };
            for (let k = currentCount; k < targetCount; k++) {
              updatedSerials.push({ variant_id: base.variant_id, serial_no: base.serial_no || '' });
            }
          }
        }
        return { ...i, qty: newQty, serial_nos: updatedSerials };
      }
      return i;
    }));
  };

  return (

    <>
      <div className="row pos-wrapper" style={{ transform: "none" }}>
        {/* Products */}
        <div className="col-12 col-md-7 col-lg-7 col-xl-8 d-flex pos-products-section">
          <div style={{ position: 'relative', width: '100%', display: 'none' }}>
            {/* Hidden Input to capture scanner */}
            <input
              ref={inputRef}
              type="text"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const code = e.target.value.trim();
                  setScannedCode(code);
                  handleBarcodeScan(code);
                  e.target.value = ''; // clear input after scan
                }
              }}
              style={{
                position: 'absolute',
                opacity: 0,
                pointerEvents: 'none',
                height: 0,
                width: 0,
              }}
              autoFocus
            />

            {/* Feedback Display */}
            {status && (
              <div className={`alert alert-${status.type === 'success' ? 'success' : 'danger'} mt-2`} style={{ fontSize: '14px' }}>
                {status.message}
              </div>
            )}
            {showScanner && (
              <div className="position-absolute top-100 start-0 mt-2 bg-white border rounded shadow-lg" style={{ zIndex: 1050, width: '520px' }}>
                <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
                  <h6 className="mb-0">Barcode Scanner</h6>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowScanner(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="p-2">
                  <div
                    style={{
                      width: "100%",
                      height: "200px",
                      border: "2px solid #333",
                      borderRadius: "4px",
                      overflow: "hidden",
                      position: "relative",
                      background: "#000",
                    }}
                  >
                    {/* Scanner overlay */}
                    <div
                      style={{
                        border: "2px dashed #fff",
                        position: "absolute",
                        top: "15%",
                        left: "10%",
                        width: "80%",
                        height: "70%",
                        zIndex: 10,
                      }}
                    />

                    <video ref={scannerRef} style={{ width: '100%', height: '200px' }} />

                    {/* Status indicator */}
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        background: isScanning ? "#00ff00" : "#ff0000",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        zIndex: 20,
                      }}
                    >
                      {isScanning ? "Scanning..." : "Stopped"}
                    </div>
                  </div>
                  <div className="mt-2 text-center">
                    {scannerError ? (
                      <div className="alert alert-danger py-2 px-3 mb-0" style={{ fontSize: '0.875rem' }}>
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {scannerError}
                      </div>
                    ) : (
                      <small className="text-muted">
                        {isScanning ? "Scanning..." : "Scanner ready"}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            )}
            {scanningProduct && (
              <div className="position-absolute top-100 start-50 translate-middle-x mt-2" style={{ zIndex: 1060 }}>
                {scanningProduct.loading && (
                  <div className="alert alert-info mb-0 py-2 px-3" style={{ fontSize: '0.875rem' }}>
                    <i className="fas fa-spinner fa-spin me-2"></i>
                    Scanning barcode: {scanningProduct.barcode}
                  </div>
                )}
                {scanningProduct.success && (
                  <div className="alert alert-success mb-0 py-2 px-3" style={{ fontSize: '0.875rem' }}>
                    <i className="fas fa-check me-2"></i>
                    Product added to cart!
                  </div>
                )}
                {scanningProduct.error && (
                  <div className="alert alert-danger mb-0 py-2 px-3" style={{ fontSize: '0.875rem' }}>
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {scanningProduct.error}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="pos-categories tabs_wrapper p-0 flex-fill">
            <div className="content-wrap pt-4">
              <div className="tab-content-wrap">
                <div className="d-flex align-items-center justify-content-between flex-wrap mb-2" style={{ width: "99%" }}>
                  <div className="mb-3">
                    <h5 className="mb-1">Welcome, {companyData?.company_name}</h5>
                    <p>December 24, 2024</p>
                  </div>
                  <div className="d-flex align-items-center flex-wrap mb-2">
                    <div className="input-group me-2" style={{ width: "250px" }}>
                      <span className="input-group-text">
                        <i className="ti ti-search"></i>
                      </span>

                      <input
                        ref={searchRef}
                        type="text"
                        className="form-control"
                        placeholder="Search products... (press / to focus)"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                          setSelectedProductIndex(0);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch(search);
                          }
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-outline-light"
                        onClick={() => handleSearch(search)}
                        title="Search"
                      >
                        <Search size={16} />
                      </button>
                    </div>

                    <button
                      className="btn btn-outline-danger me-2"
                      onClick={() => handleCleanSearch()}
                      title="Reset Search"
                    >
                      <RotateCcw size={15} />
                    </button>

                    <div className="btn-group me-2" role="group">
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => setViewMode('list')}
                        title="List View"
                      >
                        <LayoutList size={16} />
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                        onClick={() => setViewMode('grid')}
                        title="Grid View"
                      >
                        <LayoutGrid size={16} />
                      </button>
                    </div>

                    <button
                      className={`btn btn-${isScanning ? 'secondary' : 'primary'} d-flex align-items-center gap-2`}
                      onClick={handleBarcodeStart}
                      title="Scan Barcode (Ctrl+B)"
                    >
                      <ScanBarcode className='me-1' />
                      <strong className='fs-15'>{isScanning ? 'Stop' : 'Scan'}</strong>
                    </button>

                  </div>

                </div>
                <div className="pos-products" style={{ width: "99%" }}>
                  <div className="tabs_container">
                    <div className="tab_content active" ref={containerRef} style={{ minHeight: 300 }} data-tab="all">
                      {loading && (
                        <div className="col-12 text-center py-5">
                          <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p className="mt-2 text-muted">Loading products...</p>
                        </div>
                      )}
                      <div className={viewMode === 'list' ? "row g-2" : "row g-3"}>
                        {!loading && filteredProducts.map((product, idx) => {
                          const vars = Array.isArray(product.variations) ? product.variations : [];
                          const isLooseProduct = product.product_value_type === 'Loose' || 
                            billingFor === 'Loose' || 
                            (product.brand_name && product.brand_name.toUpperCase().includes('LOOSE')) ||
                            vars.some(v => Number(v.loose_qty || 0) > 0);
                          const totalLooseVol = vars.reduce((sum, v) => sum + Number(v.loose_qty || 0), 0);
                          const totalBottleQty = vars.reduce((sum, v) => sum + Number(v.qty || 0), 0);
                          const totalWholesaleQty = vars.reduce((sum, v) => sum + Number(v.current_wholesale || 0), 0);
                          const unitLabel = product.unit === '2' ? 'GM' : 'ML';

                          const displayQtyText = (() => {
                            if (vars.length === 0) return '0';
                            if (isLooseProduct) {
                              if (totalLooseVol > 0) {
                                return totalBottleQty > 0 ? `${totalLooseVol} ${unitLabel} (${totalBottleQty} Btl)` : `${totalLooseVol} ${unitLabel}`;
                              }
                              return `0 ${unitLabel}`;
                            }
                            if (billType === 'Wholesale') return `${totalWholesaleQty}`;
                            return `${totalBottleQty}`;
                          })();

                          const isAddDisabled = (() => {
                            if (vars.length === 0) return true;
                            if (isLooseProduct) return totalLooseVol <= 0;
                            if (billType === 'Wholesale') return totalWholesaleQty <= 0;
                            return totalBottleQty <= 0;
                          })();

                          const isSelected = selectedProductIndex === idx && focusArea === 'products';

                          if (viewMode === 'list') {
                            return (
                              <div key={`${product.id}-${idx}`} className="col-12">
                                <div className={`card mb-0 p-2 ${isSelected ? 'border-primary border-3 shadow-sm' : 'border-light'}`} style={{ borderRadius: '8px', transition: 'all 0.15s ease-in-out' }}>
                                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                    <div className="d-flex align-items-center gap-3 flex-grow-1" style={{ cursor: 'pointer' }} onClick={() => handleProductVariant(product, idx)}>
                                      <img
                                        src={`${API_URL}/${product.product_image}`}
                                        alt={product?.name || 'Product'}
                                        className="rounded border p-1"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = './logo.png';
                                        }}
                                        style={{ width: 44, height: 44, objectFit: 'contain', backgroundColor: '#f8f9fa' }}
                                      />
                                      <div>
                                        <h6 className="mb-0 font-bold text-dark" style={{ fontSize: '15px' }}>
                                          {(product?.name || '').replace(/-+$/, '')}
                                        </h6>
                                        <div className="d-flex flex-wrap gap-2 align-items-center mt-1">
                                          {(product.category_name || product.category?.name) && (
                                            <span className="badge bg-info-subtle text-info border border-info-subtle fw-semibold" style={{ fontSize: '0.78rem' }}>
                                              Cat: {product.category_name || product.category?.name}
                                            </span>
                                          )}
                                          {product.brand_name && (
                                            <span className="badge bg-primary-subtle text-primary border border-primary-subtle fw-semibold" style={{ fontSize: '0.78rem' }}>
                                              Brand: {product.brand_name}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 ms-auto">
                                      <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: '13px' }}>
                                        Qty: <strong>{displayQtyText}</strong>
                                      </span>
                                      <div className="btn-group">
                                        <button onClick={() => handleProductVariant(product, idx)} className={`btn btn-sm text-white ${isAddDisabled ? 'bg-danger' : 'bg-primary'}`} disabled={isAddDisabled}>
                                          Add
                                        </button>
                                        <button onClick={() => handleStockDetailModel(product, idx)} className="btn btn-sm text-white bg-info">
                                          Stock
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          return (
                            <div key={`${product.id}-${idx}`} className="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3" >
                              <div className={`product-info card mb-0 ${isSelected ? 'border-primary border-3' : ''}`}>
                                <Link onClick={() => handleProductVariant(product, idx)} className="pro-img">
                                  <img
                                    src={`${API_URL}/${product.product_image}`}
                                    alt={product?.name || 'Product'}
                                    className="card-img-top mx-auto mt-3"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src = './logo.png'; // fallback logo on load error
                                    }}
                                    style={{ width: "100%", height: 100, objectFit: 'contain', }}
                                  />
                                  <span>
                                    <i className="ti ti-circle-check-filled" />
                                  </span>
                                </Link>
                                <h6 className="product-name" style={{ textWrap: 'auto', marginBottom: '2px' }}>
                                  {(product?.name || '').replace(/-+$/, '')}
                                </h6>
                                <div className="d-flex flex-wrap gap-1 align-items-center mb-1">
                                  {(product.category_name || product.category?.name) && (
                                    <span className="badge bg-info-subtle text-info border border-info-subtle fw-semibold" style={{ fontSize: '0.72rem' }}>
                                      Cat: {product.category_name || product.category?.name}
                                    </span>
                                  )}
                                  {product.brand_name && (
                                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle fw-semibold" style={{ fontSize: '0.72rem' }}>
                                      Brand: {product.brand_name}
                                    </span>
                                  )}
                                </div>
                                <div className="d-flex align-items-center justify-content-between price">
                                  <p className="text-gray-9 mb-0">Current Qty: {displayQtyText}</p>
                                  <div className="qty-item m-0 d-flex justify-content-between gap-2">
                                    <button onClick={() => handleProductVariant(product, idx)} className={`btn btn-sm text-white w-100 ${isAddDisabled ? 'bg-danger' : 'bg-primary'}`} disabled={isAddDisabled}>Add</button>
                                    <button onClick={() => handleStockDetailModel(product, idx)} className={`btn btn-sm text-white w-100 bg-info`}>Stock</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Products */}
        {/* Order Details */}
        <div
          className="col-12 col-md-5 col-lg-5 col-xl-4 ps-md-0 theiaStickySidebar d-flex pos-cart-section"
          style={{
            position: "relative",
            overflow: "visible",
            boxSizing: "border-box",
            minHeight: 1
          }}
        >
          <div
            className="theiaStickySidebar"
            style={{
              paddingTop: 0,
              paddingBottom: 1,
              position: "static",
              transform: "none"
            }}
          >
            <aside className="product-order-list bg-secondary-transparent flex-fill">
              <div className="card">
                <div className="card-body">
                  {editingDraftBillId && (
                    <div className="alert alert-warning py-2 px-3 mb-3 rounded-3 shadow-sm d-flex justify-content-between align-items-center border-warning">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span className="badge bg-warning text-dark font-monospace fs-12">EDITING DRAFT</span>
                          <strong className="text-dark fs-14">#{editingDraftBillNo}</strong>
                        </div>
                        <small className="text-muted d-block" style={{ fontSize: '11px' }}>
                          Modifying items in cart will update this draft bill when saved or checked out.
                        </small>
                      </div>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger py-1 px-2"
                        onClick={handleCancelDraftEdit}
                        title="Exit draft editing mode"
                      >
                        <i className="ti ti-x me-1" />Cancel
                      </button>
                    </div>
                  )}
                  <div className="order-head d-flex align-items-center justify-content-between w-100">
                    <div>
                      <h3>Order List</h3>
                    </div>
                    <div className="d-flex align-items-center gap-2">

                      <button className="btn btn-info btn-sm me-2" onClick={() => setOtherModalOpen(true)}>Old Product</button>
                      <button className="btn btn-danger btn-sm" onClick={handleEmptyCart}> <i className="ti ti-trash-x-filled" /> Empty Cart</button>

                    </div>
                  </div>
                  <div className="customer-info block-section">
                    <div className="d-flex mb-3 gap-0" style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #7367f0' }}>
                      <button
                        className={`btn flex-fill py-2 fw-bold ${billType === 'Retail' ? 'btn-primary' : 'btn-white text-primary'}`}
                        onClick={() => setBillType('Retail')}
                        style={{ borderRadius: '0', border: 'none' }}
                      >
                        <i className={`ti ti-shopping-cart${billType === 'Retail' ? '-filled' : ''} me-2`} />
                        Retail Order
                      </button>
                      <button
                        className={`btn flex-fill py-2 fw-bold ${billType === 'Wholesale' ? 'btn-primary' : 'btn-white text-primary'}`}
                        onClick={() => setBillType('Wholesale')}
                        style={{ borderRadius: '0', border: 'none' }}
                      >
                        <i className={`ti ti-building-store${billType === 'Wholesale' ? '-filled' : ''} me-2`} />
                        Wholesale Order
                      </button>
                    </div>

                    {billType === 'Retail' && (
                      <div className="d-flex mb-3 gap-0" style={{ borderRadius: '8px', overflow: 'hidden', border: '1px solid #7367f0', fontSize: '12px' }}>
                        <button
                          className={`btn flex-fill py-1 ${paperSize === 'A5' ? 'btn-primary' : 'btn-white text-primary'}`}
                          onClick={() => setPaperSize('A5')}
                          style={{ borderRsadius: '0', border: 'none' }}
                        >
                          A5 Format
                        </button>
                        <button
                          className={`btn flex-fill py-1 ${paperSize === '80mm' ? 'btn-primary' : 'btn-white text-primary'}`}
                          onClick={() => setPaperSize('80mm')}
                          style={{ borderRadius: '0', border: 'none' }}
                        >
                          3 inch (Thermal)
                        </button>
                      </div>
                    )}
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <h5 className="mb-0">Customer Information</h5>
                      <div className="form-check form-switch m-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="posIsWholesalerSwitch"
                          checked={isWholesaler}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setIsWholesaler(checked);
                            if (checked) setBillType('Wholesale');
                          }}
                        />
                        <label className="form-check-label fw-bold text-primary small cursor-pointer" htmlFor="posIsWholesalerSwitch">
                          Is Wholesaler
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className='row g-2'>

                        <div className='col-12'>
                          <div className="position-relative mb-2 mt-2" ref={customerDropdownRef}>
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2" style={{ zIndex: 5 }}>
                              Customer Name
                            </span>
                            <input
                              type="text"
                              name="name"
                              className='form-control form-control-sm'
                              value={customerName}
                              onChange={handleCustomerNameSearch}
                              onFocus={(e) => {
                                if (e.target.value.trim().length >= 2) {
                                  const filtered = customers.filter((c) =>
                                    c.name && c.name.toLowerCase().includes(e.target.value.toLowerCase())
                                  ).slice(0, 10);
                                  setFilteredCustomers(filtered);
                                  setShowCustomerDropdown(filtered.length > 0);
                                }
                              }}
                              placeholder='Search Customer Name'
                              autoComplete='off'
                            />
                            {showCustomerDropdown && filteredCustomers.length > 0 && (
                              <div
                                className="shadow-lg border rounded"
                                style={{
                                  position: 'absolute',
                                  top: '100%',
                                  left: 0,
                                  right: 0,
                                  zIndex: 1050,
                                  maxHeight: '220px',
                                  overflowY: 'auto',
                                  background: '#fff',
                                }}
                              >
                                {filteredCustomers.map((cust, idx) => (
                                  <div
                                    key={cust.id || idx}
                                    className="px-3 py-2 border-bottom"
                                    style={{
                                      cursor: 'pointer',
                                      fontSize: '13px',
                                      transition: 'background 0.15s',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.background = '#f0f0ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.background = '#fff'}
                                    onClick={() => handleSelectCustomer(cust)}
                                  >
                                    <div className="fw-semibold" style={{ color: '#333' }}>{cust.name}</div>
                                    <div className="text-muted" style={{ fontSize: '11px' }}>
                                      {cust.phone && <span className="me-2"><i className="ti ti-phone me-1" />{cust.phone}</span>}
                                      {cust.company_name && <span><i className="ti ti-building me-1" />{cust.company_name}</span>}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className='col-6'>

                          <div className="position-relative mb-2 mt-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              Mobile
                            </span>
                            <input type="text" name="mobile_no" className='form-control form-control-sm' value={customerMobile} onChange={(e) => callCustomerDataApi(e)} placeholder='Customer Mobile' />
                          </div>
                        </div>

                        <div className='col-6'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              Email
                            </span>
                            <input type="text" name="name" className='form-control form-control-sm' value={customerEmail} onChange={(e) => setCustomerEmail(e.target.value)} placeholder='Customer Email' />
                          </div>

                        </div>

                        <div className='col-6'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              Country
                            </span>
                            <select
                              className='form-control form-control-sm'
                              value={selectedCountry}
                              onChange={e => {
                                setSelectedCountry(e.target.value);
                                setSelectedState('');
                                setSelectedCity('');
                              }}
                            >
                              {countries.map(c => (
                                <option key={c.isoCode} value={c.name}>
                                  {c.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className='col-6'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              State
                            </span>
                            <select
                              className='form-control form-control-sm'
                              value={selectedState}
                              onChange={e => {
                                setSelectedState(e.target.value);
                                setSelectedCity('');
                              }}
                            >
                              <option value="">-- Select State --</option>
                              {states.map(s => (
                                <option key={s.isoCode} value={s.name}>
                                  {s.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className='col-6'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              City
                            </span>
                            <select
                              className='form-control form-control-sm'
                              value={selectedCity}
                              onChange={e => setSelectedCity(e.target.value)}
                            >
                              <option value="">-- Select City --</option>
                              {cities.map(city => (
                                <option key={city.name} value={city.name}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className='col-6'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              DL No.
                            </span>
                            <input type="text" name="dl_no" value={customerDlNo} onChange={(e) => setCustomerDlNo(e.target.value)} className='form-control form-control-sm' placeholder='DL No.' />
                          </div>
                        </div>

                        <div className='col-12'>
                          <div className="position-relative mt-2 mb-2">
                            <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                              Aadhar No. (Optional)
                            </span>
                            <input type="text" name="aadhar_no" value={customerAadharNo} onChange={(e) => setCustomerAadharNo(e.target.value)} className='form-control form-control-sm' placeholder='Aadhar No. (Optional)' />
                          </div>
                        </div>

                      </div>

                      <div className="position-relative mt-2 mb-2">
                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                          Customer Address
                        </span>
                        <input type="text" name="address" value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)} className='form-control form-control-sm' placeholder='Customer Address' />
                      </div>
                      <div className="position-relative mt-2 mb-2">
                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                          Customer GST No.
                        </span>
                        <input type="text" name="gst_no" value={customerGstNo} onChange={(e) => setCustomerGstNo(e.target.value)} className='form-control form-control-sm' placeholder='Customer GST No.' />
                      </div>
                    </div>

                  </div>
                  <div className="product-added block-section mb-0">
                    <div className="head-text d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <h5 className="me-2">Order Details</h5>
                        <div className="badge bg-light text-gray-9 fs-12 fw-semibold py-2 border rounded">
                          Items : <span className="text-teal">{cart.length}</span>
                        </div>
                      </div>
                      <Link
                        onClick={handleEmptyCart}
                        className="d-flex align-items-center clear-icon fs-10 fw-medium"
                      >
                        Clear all
                      </Link>
                    </div>
                    <div className="product-wrap">
                      <div className="product-list border-0 p-0" style={{ display: 'block' }}>
                        <div className="table-responsive" style={{ width: "100%" }}>
                          <div className="flex-grow-1 overflow-auto border rounded mb-3 pos-cart-items-scroll">
                            <table className="table table-primary table-sm mb-0">
                              <thead>
                                <tr style={{ borderColor: '#D63031' }}>
                                  <th style={{ border: "none" }}>Name</th>
                                  <th style={{ border: "none" }}>Qty</th>
                                  <th style={{ border: "none" }}>Price</th>
                                  {/* <th style={{ border: "none" }}>Tax</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {cart.length === 0 ? (
                                  <tr><td colSpan="5" className="text-center text-muted">Cart empty</td></tr>
                                ) : (
                                  cart.map((item, idx) => {
                                    const calc = getItemCalculations(item);
                                    return (
                                      <tr
                                        style={{ borderBottom: "1px solid #eee" }}
                                        key={`${item.id}-${idx}`}
                                        className={focusArea === 'cart' && selectedCartIndex === idx ? 'table-primary' : ''}
                                      >
                                        <td style={{ border: "none" }}>
                                          <div style={{ maxWidth: '240px', width: '240px', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', fontWeight: '500' }}>
                                            {(item?.name || item?.product_name || '').replace(/-+$/, '')}
                                          </div>
                                          <div className="mt-1 d-flex flex-wrap gap-1 align-items-center">
                                            {(item.category_name || item.category?.name) && (
                                              <span className="badge bg-secondary text-white" style={{ fontSize: "0.7rem" }}>
                                                Cat: {item.category_name || item.category?.name}
                                              </span>
                                            )}
                                            {item.batch_no && (
                                              <span className="badge bg-warning text-dark border border-warning" style={{ fontSize: "0.7rem" }}>
                                                Batch: {item.batch_no}
                                              </span>
                                            )}
                                            {item.exp_date && (
                                              <span className="badge bg-light text-danger border border-danger" style={{ fontSize: "0.7rem" }}>
                                                Exp: {new Date(item.exp_date).toLocaleDateString('en-IN')}
                                              </span>
                                            )}
                                            {(item.year || item.price_date) && (
                                              <span className="badge bg-dark text-white" style={{ fontSize: "0.7rem" }}>
                                                Year: {item.year || new Date(item.price_date).getFullYear()}
                                              </span>
                                            )}
                                            {item.serial_nos?.map((s, sidx) => (
                                              <span
                                                key={`${s.serial_no}-${sidx}`}
                                                className="badge bg-primary text-white d-flex align-items-center"
                                                style={{ fontSize: "0.75rem", padding: "0.4em 0.6em" }}
                                              >
                                                {s.serial_no}
                                                <button
                                                  type="button"
                                                  className="btn-close btn-close-white btn-sm ms-2"
                                                  style={{ fontSize: "0.6rem" }}
                                                  onClick={() => handleDecreaseQty(item.cartKey || item.id, sidx)}
                                                />
                                              </span>
                                            ))}
                                          </div>

                                          {/* Item Discount & Free Controls */}
                                          <div className="mt-1 d-flex flex-wrap gap-1 align-items-center">
                                            <div className="d-inline-flex align-items-center gap-1 bg-light px-1 py-0 rounded border">
                                              <span className="text-muted" style={{ fontSize: "0.7rem" }}>Disc:</span>
                                              <select
                                                className="form-select form-select-sm p-0 ps-1 border-0 bg-transparent"
                                                style={{ fontSize: "0.7rem", height: "20px", width: "36px", cursor: "pointer" }}
                                                value={item.discount_type || 'percentage'}
                                                disabled={item.is_free}
                                                onChange={e => handleItemDiscountChange(item.cartKey || item.id, 'discount_type', e.target.value)}
                                              >
                                                <option value="percentage">%</option>
                                                <option value="fixed">₹</option>
                                              </select>
                                              <input
                                                type="number"
                                                min="0"
                                                placeholder="0"
                                                className="form-control form-control-sm p-0 ps-1 border-0 bg-white"
                                                style={{ fontSize: "0.7rem", height: "20px", width: "45px" }}
                                                value={item.discount_value !== undefined && item.discount_value !== null ? item.discount_value : ''}
                                                disabled={item.is_free}
                                                onChange={e => handleItemDiscountChange(item.cartKey || item.id, 'discount_value', e.target.value)}
                                              />
                                            </div>

                                            <button
                                              type="button"
                                              className={`btn btn-sm py-0 px-2 ${item.is_free ? 'btn-success text-white fw-bold' : 'btn-outline-secondary'}`}
                                              style={{ fontSize: "0.7rem", height: "22px" }}
                                              onClick={() => handleItemFreeToggle(item.cartKey || item.id)}
                                              title={item.is_free ? "Marked as 100% Free" : "Click to make this item Free"}
                                            >
                                              {item.is_free ? '✓ FREE' : 'Make Free'}
                                            </button>

                                            {!item.is_free && item.qty > 1 && (
                                              <div className="d-inline-flex align-items-center gap-1 bg-light px-1 py-0 rounded border">
                                                <span className="text-muted" style={{ fontSize: "0.7rem" }}>Free:</span>
                                                <input
                                                  type="number"
                                                  min="0"
                                                  max={item.qty}
                                                  placeholder="0"
                                                  className="form-control form-control-sm p-0 ps-1 border-0 bg-white"
                                                  style={{ fontSize: "0.7rem", height: "20px", width: "38px" }}
                                                  value={item.free_qty || ''}
                                                  onChange={e => handleItemFreeQtyChange(item.cartKey || item.id, e.target.value)}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        </td>
                                        <td style={{ border: "none" }}>
                                          <div className="d-flex align-items-center gap-1">
                                            <span className='text-center'><strong>{item.qty}</strong></span>
                                            <button
                                              className="btn btn-sm btn-link text-primary p-0"
                                              onClick={() => handleEditQty(item)}
                                              title="Edit Quantity"
                                              style={{ textDecoration: 'none' }}
                                            >
                                              <Pen size={12} />
                                            </button>
                                          </div>
                                          {calc.freeQty > 0 && !item.is_free && (
                                            <div className="badge bg-info text-white" style={{ fontSize: '0.65rem' }}>
                                              {calc.billedQty} + {calc.freeQty} Free
                                            </div>
                                          )}
                                        </td>
                                        <td style={{ border: "none" }}>
                                          {item.is_free ? (
                                            <div>
                                              <div className="text-decoration-line-through text-muted" style={{ fontSize: "0.72rem" }}>
                                                ₹{calc.originalInclusiveTotal.toFixed(2)}
                                              </div>
                                              <div className="text-success fw-bold" style={{ fontSize: "0.85rem" }}>
                                                ₹0.00 <span className="badge bg-success" style={{ fontSize: "0.62rem" }}>FREE</span>
                                              </div>
                                            </div>
                                          ) : (calc.itemDiscountAmount > 0 || calc.freeQty > 0) ? (
                                            <div>
                                              <div className="text-decoration-line-through text-muted" style={{ fontSize: "0.72rem" }}>
                                                ₹{calc.originalInclusiveTotal.toFixed(2)}
                                              </div>
                                              <div className="text-primary fw-bold" style={{ fontSize: "0.85rem" }}>
                                                ₹{calc.itemNetInclusive.toFixed(2)}
                                              </div>
                                              <div className="text-danger" style={{ fontSize: "0.68rem" }}>
                                                -₹{calc.itemDiscountAmount.toFixed(2)} {calc.freeQty > 0 ? `(${calc.freeQty} Free)` : ''}
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="fw-semibold">
                                              ₹{calc.itemNetInclusive.toFixed(2)}
                                            </div>
                                          )}
                                          <button
                                            className="btn btn-sm btn-link text-primary ms-1 p-0"
                                            type="button"
                                            title="Edit Price"
                                            onClick={() => handleEditPrice(item)}
                                          >
                                            <Pen size={14} />
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-2 d-flex align-items-center justify-content-end gap-2">
                    <label className="me-2 mb-0">Bill Discount:</label>
                    <select
                      className="form-select form-select-sm w-auto"
                      value={discountType}
                      onChange={e => setDiscountType(e.target.value)}
                    >
                      <option value="fixed">₹ Fixed</option>
                      <option value="percentage">% Percent</option>
                    </select>
                    <input
                      type="number"
                      className="form-control form-control-sm w-auto"
                      style={{ maxWidth: 100 }}
                      value={discountValue}
                      min={0}
                      onChange={e => setDiscountValue(e.target.value)}
                      placeholder={discountType === 'fixed' ? 'Amount' : 'Percent'}
                    />
                  </div>
                  <div className="order-total bg-total bg-white p-0 table-responsive">
                    <h5 className="mb-3">Payment Summary</h5>
                    <table className="table table-responsive table-borderless mb-4">
                      <tbody>
                        {totalLineItemDiscounts > 0 && (
                          <tr>
                            <td style={{ border: 'none' }}>
                              Item Discounts
                            </td>
                            <td style={{ border: 'none' }} className="text-danger text-end">-₹{totalLineItemDiscounts.toFixed(2)}</td>
                          </tr>
                        )}
                        {discountAmount > 0 && (
                          <tr>
                            <td style={{ border: 'none' }}>
                              Bill Discount
                            </td>
                            <td style={{ border: 'none' }} className="text-danger text-end">-₹{discountAmount.toFixed(2)}</td>
                          </tr>
                        )}
                        <tr>
                          <td style={{ border: 'none' }}>
                            Taxable Amount
                          </td>
                          <td style={{ border: 'none' }} className="text-gray-9 text-end">₹{displayTaxableAmount.toFixed(2)}</td>
                        </tr>
                        {companyData?.state == selectedState ? (
                          <>
                            <tr>
                              <td style={{ border: 'none' }}>
                                CGST
                              </td>
                              <td style={{ border: 'none' }} className="text-gray-9 text-end">₹{cgst_sgst_val.toFixed(2)}</td>
                            </tr>
                            <tr>
                              <td style={{ border: 'none' }}>
                                SGST
                              </td>
                              <td style={{ border: 'none' }} className="text-gray-9 text-end">₹{cgst_sgst_val.toFixed(2)}</td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td style={{ border: 'none' }}>
                              IGST
                            </td>
                            <td style={{ border: 'none' }} className="text-gray-9 text-end">₹{igst_val.toFixed(2)}</td>
                          </tr>
                        )}


                        <tr>
                          <td style={{ border: 'none' }} className="fw-bold border-top border-dashed">
                            Total Payable
                          </td>
                          <td style={{ border: 'none' }} className="text-gray-9 fw-bold text-end border-top border-dashed">
                            ₹{totalAfterDiscount.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <input type="hidden" className="form-control" placeholder="Enter amount" value={totalAfterDiscount.toFixed(2)} />
                    {/* Payment Mode Dropdown and Cash Return */}
                    <div className='mb-2'>
                      <div className='d-flex'>
                        <div className='flex-grow-1'>
                          <label className="form-label">Is Older Bill</label><br />
                          <input type="checkbox" className="form-check-input ms-2" checked={isOlderBill} onChange={e => setIsOlderBill(e.target.checked)} />
                        </div>
                        {isOlderBill && <div className='position-relative mt-3 flex-grow-1'>
                          <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                            Bill Date
                          </span>

                          <input type="datetime-local" className="form-control" value={billDate} onChange={e => setBillDate(e.target.value)} />
                        </div>}
                      </div>
                    </div>
                    {/* <div className='position-relative mt-3 mb-2'>
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Bill Type
                      </span>
                      <select className="form-select" value={billType} onChange={e => setBillType(e.target.value)}>
                        <option value="">Select Bill Type</option>
                        <option value="Online">Online</option>
                        <option value="Retail">Retail</option>
                        <option value="Wholesale">Wholesale</option>
                      </select>
                    </div> */}
                    <div className='position-relative mt-3 mb-2'>
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Billing For
                      </span>
                      <select className="form-select" value={billingFor} onChange={e => {
                        const val = e.target.value;
                        setBillingFor(val);
                        fetchNextInvoiceNo(val);
                      }}>
                        <option value="">Select Billing For</option>
                        <option value="Product">Product</option>
                        <option value="Services">Services</option>
                        <option value="Non-GST">Non-GST</option>
                      </select>
                    </div>
                    <div className='position-relative mt-3 mb-2'>
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Invoice No
                      </span>
                      <input
                        type="text"
                        className={`form-control ${invoiceTaken ? 'is-invalid border-danger' : invoiceChecked && invoiceNo ? 'is-valid' : ''}`}
                        value={invoiceNo}
                        onChange={(e) => {
                          setInvoiceNo(e.target.value);
                          setInvoiceTaken(false);
                          setInvoiceChecked(false);
                        }}
                        onBlur={() => checkInvoiceNo(invoiceNo)}
                        placeholder="Invoice No"
                      />
                      {invoiceTaken && (
                        <div className="invalid-feedback d-block fw-bold text-danger mt-1">
                          Already created!
                        </div>
                      )}
                    </div>
                    <div className='position-relative mt-3 mb-2'>
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Sales Executive
                      </span>
                      <select className="form-select" value={salesExecutive} onChange={e => setSalesExecutive(e.target.value)}>
                        <option value="">Select Sales Executive</option>
                        {salesExecutives.map(exec => (
                          <option key={exec.id} value={exec.id}>{exec.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="position-relative mt-3 mb-2">
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Mode of Payment
                      </span>
                      <select className="form-select" value={paymentMode} onChange={e => setPaymentMode(e.target.value)}>
                        <option value="Cash">Cash</option>
                        <option value="Kotak UPI">Kotak UPI</option>
                        <option value="Indusind UPI">Indusind UPI</option>
                        <option value="Cheque">Cheque</option>
                        <option value="Axis Bank Pos">Axis Bank Pos</option>
                        <option value="Phonepe - UCO Bank Pos">Phonepe - UCO Bank Pos</option>
                        <option value="Gpay UPI">Gpay UPI</option>
                        <option value="Phonepe upi">Phonepe upi</option>
                        <option value="Paytm upi">Paytm upi</option>
                        <option value="Bharat pay upi">Bharat pay upi</option>
                        <option value="Debit card">Debit card</option>
                        <option value="Credit card">Credit card</option>
                        <option value="Bhim upi">Bhim upi</option>
                        <option value="Amazon pay upi">Amazon pay upi</option>
                        <option value="Partial Payment">Partial Payment</option>
                      </select>
                    </div>
                    {paymentMode === 'Partial Payment' && (
                      <div className="mb-2">
                        <div className="row">
                          <div className="col-6">
                            <div className='position-relative mt-3 mb-2'>
                              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Partial Payment 1
                              </span>
                              <select className="form-select mb-1" value={partialFirstMode} onChange={e => setPartialFirstMode(e.target.value)}>
                                <option value="">Select Mode</option>
                                <option value="Cash">Cash</option>
                                <option value="Gpay UPI">Gpay UPI</option>
                                <option value="Phonepe upi">Phonepe upi</option>
                                <option value="Paytm upi">Paytm upi</option>
                                <option value="Bharat pay upi">Bharat pay upi</option>
                                <option value="Debit card">Debit card</option>
                                <option value="Credit card">Credit card</option>
                                <option value="Bhim upi">Bhim upi</option>
                                <option value="Amazon pay upi">Amazon pay upi</option>
                                <option value="Axis Bank Pos">Axis Bank Pos</option>
                                <option value="Phonepe - UCO Bank Pos">Phonepe - UCO Bank Pos</option>
                              </select>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Amount"
                                value={partialFirstPayment}
                                min={0}
                                onChange={e => {
                                  setPartialFirstPayment(e.target.value);
                                  setPartialSecondPayment(totalAfterDiscount - e.target.value)
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-6">
                            <div className='position-relative mt-3 mb-2'>
                              <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                Partial Payment 2
                              </span>
                              <select className="form-select mb-1" value={partialSecondMode} onChange={e => setPartialSecondMode(e.target.value)}>
                                <option value="">Select Mode</option>
                                <option value="Cash">Cash</option>
                                <option value="Kotak UPI">Kotak UPI</option>
                                <option value="Indusind UPI">Indusind UPI</option>
                                <option value="Cheque">Cheque</option>
                                <option value="Gpay UPI">Gpay UPI</option>
                                <option value="Phonepe upi">Phonepe upi</option>
                                <option value="Paytm upi">Paytm upi</option>
                                <option value="Bharat pay upi">Bharat pay upi</option>
                                <option value="Debit card">Debit card</option>
                                <option value="Credit card">Credit card</option>
                                <option value="Bhim upi">Bhim upi</option>
                                <option value="Amazon pay upi">Amazon pay upi</option>
                                <option value="Axis Bank Pos">Axis Bank Pos</option>
                                <option value="Phonepe - UCO Bank Pos">Phonepe - UCO Bank Pos</option>
                              </select>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Amount"
                                value={partialSecondPayment}
                                min={0}
                                onChange={e => setPartialSecondPayment(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* <div className="position-relative mt-3 mb-2">
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                            Payment Received
                          </span>
                      <input type="number" className="form-control" value={cashReceived} min={totalAfterDiscount} onChange={e => setCashReceived(e.target.value)} placeholder="Enter Payment received" />
                      <div className="mt-1 text-success">
                        {cashReceived > (paymentMode === 'Cash' ? totalAfterDiscount : paymentMode == 'Partial Payment' && partialFirstMode == 'Cash' ? partialFirstPayment : partialSecondPayment) ? `Return : ₹${Math.ceil(parseFloat(cashReceived) - (paymentMode == 'Cash' ? Math.ceil(parseFloat(totalAfterDiscount)) : paymentMode == 'Partial Payment' && partialFirstMode == 'Cash' ? Math.ceil(parseFloat(partialFirstPayment)) : Math.ceil(parseFloat(partialSecondPayment))))}` : ''}
                      </div>
                    </div> */}
                    <div className="position-relative mt-3 mb-2">
                      <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                        Payment Received
                      </span>

                      <input
                        type="number"
                        className="form-control"
                        value={cashReceived}
                        min={totalAfterDiscount}
                        onChange={e => setCashReceived(e.target.value)}
                        placeholder="Enter Payment received"
                      />

                      {/* Cheque Fields */}
                      {(paymentMode === 'Cheque' ||
                        (paymentMode === 'Partial Payment' && partialFirstMode === 'Cheque') ||
                        (paymentMode === 'Partial Payment' && partialSecondMode === 'Cheque')) && (
                          <div className="mt-2">
                            <input
                              type="text"
                              className="form-control mb-2"
                              placeholder="Enter Bank Name"
                              value={bankName}
                              onChange={(e) => setBankName(e.target.value)}
                            />

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Cheque Number"
                              value={chequeNo}
                              onChange={(e) => setChequeNo(e.target.value)}
                            />
                          </div>
                        )}

                      {/* Amount Calculation */}
                      {(() => {
                        const received = parseFloat(cashReceived || 0);

                        const payable =
                          paymentMode !== 'Partial Payment'
                            ? parseFloat(totalAfterDiscount)
                            : paymentMode === 'Partial Payment' && partialFirstMode === 'Cash'
                              ? parseFloat(partialFirstPayment)
                              : parseFloat(partialSecondPayment);

                        if (!received) return null;

                        if (received > payable) {
                          return (
                            <div className="mt-1 text-success">
                              Return : ₹{Math.ceil(received - payable)}
                            </div>
                          );
                        }

                        if (received < payable) {
                          return (
                            <div className="mt-1 text-danger">
                              Remaining : ₹{Math.ceil(payable - received)}
                            </div>
                          );
                        }
                      })()}
                    </div>
                  </div>
                </div>
              </div>

              <div className="btn-row d-flex align-items-center justify-content-between gap-3">
                <button
                  type="button"
                  className="btn btn-white d-flex align-items-center justify-content-center flex-fill m-0"
                  onClick={() => handlePayment(true)}
                >
                  {editingDraftBillId ? 'Update Draft' : 'Save Draft'}
                </button>
                <button
                  disabled={paymentMode == 'Cash' && cashReceived == ''}
                  onClick={() => handlePayment(false)}
                  className="btn btn-secondary d-flex align-items-center justify-content-center flex-fill m-0"
                >
                  <i className="ti ti-shopping-cart me-2" />
                  {editingDraftBillId ? 'Complete & Place Order' : 'Place Order'}
                </button>
              </div>
            </aside>
            <div
              className="resize-sensor"
              style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                zIndex: -1,
                visibility: "hidden"
              }}
            >
              <div
                className="resize-sensor-expand"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "all",
                    width: 570,
                    height: 257
                  }}
                />
              </div>
              <div
                className="resize-sensor-shrink"
                style={{
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  overflow: "hidden",
                  zIndex: -1,
                  visibility: "hidden"
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    transition: "0s",
                    width: "200%",
                    height: "200%"
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <PosModel show={showVariantModel} onClose={() => handleModelclose()} addCart={handleProductCardClick} heading={selectedProduct?.brand_name ? `${selectedProduct?.name} - [Brand: ${selectedProduct.brand_name}]` : selectedProduct?.name || 'Select Variant'} initialData={selectedProduct} cart={cart} billType={billType} billingFor={billingFor} />
        <StockOtherScrapModal show={openStockOtherModal} onClose={() => setStockOtherModalOpen(false)} addCart={handleProductCardClick} heading={'Stock Details'} initialData={selectedProduct} cart={cart} billType={billType} />
        <OtherScrapModal show={openOtherModal} onClose={() => setOtherModalOpen(false)} addCart={handleAddOtherProduct} heading={'Other Products'} cart={cart} />
        {/* /Order Details */}
      </div>
    </>
  );
};

export default PosPage;
